// SPDX-FileCopyrightText: Copyright Orangebot, Inc. and Medplum contributors
// SPDX-License-Identifier: Apache-2.0
export const AsyncAutocompleteTestIds = { selectedItems: 'selected-items', options: 'options' };
